import { JetView } from 'webix-jet';
import { devConfig, countries, walletsList, profile } from 'config/config';

/**
 * Class representing the FilterBetsReportView.
 * Extends JetView to create a view for filtering bets reports.
 */
export default class FilterBetsReportView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._;
        const left = {
            rows: [
                {
                    id: 'a1',
                    rows: [
                        {
                            margin: 15,
                            css: 'on-row',
                            responsive: 'a1',
                            cols: [
                                {
                                    view: 'text',
                                    minWidth: 200,
                                    name: 'DateStart',
                                    id: 'DateStart',
                                    css: 'reportrange',
                                    value:
                                        moment().subtract(0, 'days').format('YYYY-MM-DD') +
                                        ' - ' +
                                        moment().format('YYYY-MM-DD'),
                                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha Creación'),
                                    labelPosition: 'top',
                                    placeholder: _('Click para seleccionar '),
                                },
                                {
                                    view: 'datepicker',
                                    name: 'Date',
                                    id: 'Date',
                                    stringResult: true,
                                    minWidth: 200,
                                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha Creación'),
                                    labelPosition: 'top',
                                    placeholder: _('Click para seleccionar '),
                                    value: moment().format('YYYY-MM-DD'),
                                    format: '%d %M %Y',
                                    suggest: {
                                        type: 'calendar',
                                        body: {
                                            maxDate: new Date(),
                                        },
                                    },
                                },
                                {
                                    view: 'text',
                                    minWidth: 200,
                                    name: 'DateEnd',
                                    id: 'DateEnd',
                                    css: 'reportrange',
                                    value:
                                        moment().subtract(0, 'days').format('YYYY-MM-DD') +
                                        ' - ' +
                                        moment().format('YYYY-MM-DD'),
                                    readonly: true,
                                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha Expiración'),
                                    labelPosition: 'top',
                                    placeholder: _('Click para seleccionar '),
                                },
                                {
                                    view: 'datepicker',
                                    name: 'Date2',
                                    id: 'Date2',
                                    stringResult: true,
                                    minWidth: 200,
                                    label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha Expiración'),
                                    labelPosition: 'top',
                                    placeholder: _('Click para seleccionar '),
                                    value: moment().format('YYYY-MM-DD'),
                                    format: '%d %M %Y',
                                    suggest: {
                                        type: 'calendar',
                                        body: {
                                            maxDate: new Date(),
                                        },
                                    },
                                },
                                {
                                    view: 'richselect',
                                    name: 'CountrySelect',
                                    id: 'CountrySelect',
                                    minWidth: 200,
                                    localId: 'regions:combo',
                                    label: "<span class='icon-language'></span>" + _('País'),
                                    labelPosition: 'top',
                                    placeholder: _('Click para seleccionar '),
                                    options: {
                                        body: {
                                            template: function (obj) {
                                                return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                            },
                                            data: countries,
                                        },
                                    },
                                    hidden:
                                        devConfig.getCountryReport() ||
                                        !devConfig.getPermAction('filterByCountry', 'Add'),
                                    css: 'prm-filterByCountry',
                                },
                                {
                                    view: 'richselect',
                                    name: 'CountrySelect2',
                                    minWidth: 200,
                                    localId: 'regions:combo',
                                    label: "<span class='icon-language'></span>" + _('País'),
                                    labelPosition: 'top',
                                    placeholder: _('Click para seleccionar '),
                                    value: profile.Settings.ReportCountry,
                                    readonly: true,
                                    options: {
                                        body: {
                                            template: function (obj) {
                                                return "<i class='flags " + obj.icon + "'></i>" + obj.value;
                                            },
                                            data: countries,
                                        },
                                    },
                                    hidden:
                                        !devConfig.getCountryReport() ||
                                        !devConfig.getPermAction('filterByCountry', 'Add'),
                                    css: 'prm-filterByCountry',
                                    css: 'country-hide',
                                },
                                {
                                    view: 'richselect',
                                    name: 'State',
                                    minWidth: 200,
                                    localId: 'bonusStates:combo',
                                    label: "<span class='icon-state'></span>" + _('Estado'),
                                    labelPosition: 'top',
                                    placeholder: _('Click para seleccionar '),
                                    options: [
                                        {
                                            id: 'C',
                                            value: _('Abierto'),
                                        },
                                        {
                                            id: 'S',
                                            value: _('Ganó'),
                                        },
                                        {
                                            id: 'N',
                                            value: _('Perdió'),
                                        },
                                        {
                                            id: 'A',
                                            value: _('No Acción'),
                                        },
                                        {
                                            id: 'R',
                                            value: _('Pendiente'),
                                        },
                                        {
                                            id: 'W',
                                            value: _('En Espera'),
                                        },
                                        {
                                            id: 'J',
                                            value: _('Rechazada'),
                                        },
                                        {
                                            id: 'M',
                                            value: _('Rechazada por Regla'),
                                        },
                                        {
                                            id: 'T',
                                            value: _('Retiro Voluntario'),
                                        },
                                        {
                                            id: 'PP',
                                            value: _('Pendiente por pagar Punto de venta'),
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'a2',
                    rows: [
                        {
                            margin: 15,
                            css: 'on-row',
                            responsive: 'a2',
                            cols: [
                                {
                                    view: 'text',
                                    name: 'PlayerId',
                                    minWidth: 200,
                                    label: "<span class='icon-drivers-license-o'></span>" + _('Usuario Id'),
                                    labelPosition: 'top',
                                    placeholder: _('Usuario Id '),
                                    hidden: !devConfig.getPermAction('filterByUser', 'Add'),
                                    css: 'prm-filterByUser',
                                },
                                {
                                    view: 'text',
                                    name: 'TicketId',
                                    minWidth: 200,
                                    label: "<span class='icon-ticket'></span>" + _('Ticket Id'),
                                    labelPosition: 'top',
                                    placeholder: _('Ticket Id '),
                                },
                                {
                                    view: 'text',
                                    name: 'Ip',
                                    minWidth: 200,
                                    label: "<span class='icon-ip'></span>" + _('Dirección IP'),
                                    labelPosition: 'top',
                                    placeholder: _('Direccion IP '),
                                },
                                {
                                    view: 'richselect',
                                    name: 'TypeBet',
                                    id: 'TypeBet',
                                    minWidth: 200,
                                    label: _('Tipo de Apuesta'),
                                    labelPosition: 'top',
                                    placeholder: _('Click para seleccionar '),
                                    value: 2,
                                    options: [
                                        {
                                            id: '1',
                                            value: _('Apuestas Creadas'),
                                        },
                                        {
                                            id: '2',
                                            value: _('Apuestas Cerradas'),
                                        },
                                        {
                                            id: '3',
                                            value: _('Apuestas Pagadas'),
                                        },
                                        {
                                            id: '4',
                                            value: _('Apuestas Canceladas'),
                                        },
                                    ],
                                },
                                {
                                    view: 'richselect',
                                    name: 'TypeAwards',
                                    id: 'TypeAwards',
                                    minWidth: 200,
                                    label: _('Tipo para Premios'),
                                    labelPosition: 'top',
                                    placeholder: _('Click para seleccionar '),
                                    value: 2,
                                    options: [
                                        {
                                            id: '1',
                                            value: _('Apuestas Cerradas'),
                                        },
                                        {
                                            id: '2',
                                            value: _('Apuestas Pagadas'),
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'a3',
                    rows: [
                        {
                            margin: 15,
                            css: 'on-row',
                            responsive: 'a3',
                            id: 'Sort',
                            cols: [
                                {
                                    view: 'combo',
                                    name: 'Sort',
                                    label: _('Ordenar por'),
                                    labelPosition: 'top',
                                    minWidth: 200,
                                    placeholder: _('Click para seleccionar '),
                                    options: [
                                        { id: '1', value: _('Fecha Creación') },
                                        { id: '2', value: _('Usuario Id') },
                                        { id: '3', value: _('Valor') },
                                        { id: '4', value: _('GGR') },
                                    ],
                                    value: '1',
                                },
                                {
                                    view: 'combo',
                                    name: 'Dir',
                                    label: _('Orden'),
                                    labelPosition: 'top',
                                    minWidth: 200,
                                    options: [
                                        { id: '0', value: _('Ascendente') },
                                        { id: '1', value: _('Descendente') },
                                    ],
                                    value: '0',
                                },
                                {
                                    view: 'combo',
                                    name: 'WalletId',
                                    minWidth: 200,
                                    localId: 'wallet:combo',
                                    label: _('Tipo de Billetera'),
                                    labelPosition: 'top',
                                    placeholder: _('Click para seleccionar '),
                                    suggest: walletsList,
                                },
                                {
                                    view: 'checkbox',
                                    label: _('Resumido'),
                                    labelPosition: 'top',
                                    name: 'IsDetails',
                                    id: 'IsDetails',
                                    value: 0,
                                    minWidth: 200,
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'a4',
                    height: screen.width < 500 ? 350 : 0,
                    rows: [
                        {
                            margin: 15,
                            css: 'on-row',
                            responsive: 'a4',
                            cols: [
                                {
                                    view: 'text',
                                    name: 'BeneficiaryId',
                                    minWidth: 200,
                                    label: "<span class='icon-drivers-license-o'></span>" + _('Benerificario Id'),
                                    labelPosition: 'top',
                                    placeholder: _('Benerificario Id '),
                                    css: 'prm-filterByUser',
                                },
                                {},
                                {},
                                {},
                            ],
                        },
                    ],
                },
                {
                    id: 'a4',
                    height: screen.width < 500 ? 350 : 0,
                    rows: [
                        {
                            margin: 15,
                            css: 'on-row',
                            responsive: 'a4',
                            cols: [
                                {
                                    view: 'text',
                                    name: 'BetshopCreadted',
                                    minWidth: 200,
                                    label: "<span class='icon-drivers-license-o'></span>" + _('Usuario Creo'),
                                    labelPosition: 'top',
                                    placeholder: _('Usuario Creo'),
                                    hidden: !devConfig.getPermAction('filterByBetshopCreadted', 'Add'),
                                    css: 'prm-filterByBetshopCreadted',
                                },
                                {
                                    view: 'text',
                                    name: 'BetshopPaid',
                                    minWidth: 200,
                                    label: "<span class='icon-drivers-license-o'></span>" + _('Usuario Pagó'),
                                    labelPosition: 'top',
                                    placeholder: _('Usuario Pagó'),
                                    hidden: !devConfig.getPermAction('filterByBetshopPaid', 'Add'),
                                    css: 'prm-filterByBetshopPaid',
                                },
                                {
                                    view: 'radio',
                                    name: 'TypeUser',
                                    label: _('Tipo de usuario'),
                                    labelPosition: 'top',
                                    height: screen.width < 500 ? 150 : 0,
                                    value: 0,
                                    options: [
                                        { id: 0, value: _('Todos') },
                                        {
                                            id: 1,
                                            value: "<span class='icon-players'></span> ",
                                        },
                                        {
                                            id: 2,
                                            value: "<span class='icon-shop'></span>",
                                        },
                                        {
                                            id: 3,
                                            value: "<img src='https://images.virtualsoft.tech/m/msj0212T1708021015.png' alt='icon'>",
                                        },
                                    ],
                                },
                                {
                                    view: 'radio',
                                    name: 'Delete',
                                    label: _('Con Eliminadas?'),
                                    labelPosition: 'top',
                                    height: screen.width < 500 ? 150 : 0,
                                    value: 'N',
                                    options: [
                                        { id: 'N', value: _('No') },
                                        { id: 'S', value: _('Sí') },
                                    ],
                                },
                            ],
                        },
                    ],
                },
            ],
        };
        const left2 = {
            margin: 5,
            id: 'b2',
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    responsive: 'b2',
                    cols: [
                        {
                            view: 'text',
                            name: 'ValueMinimum',
                            type: 'number',
                            minWidth: 200,
                            label: "<span class='icon-cash'></span>" + _('Premio Total Mínimo'),
                            labelPosition: 'top',
                            placeholder: _('Premio Total Mínimo'),
                        },
                        {
                            view: 'text',
                            name: 'ValueMaximum',
                            type: 'number',
                            minWidth: 200,
                            label: "<span class='icon-cash'></span>" + _('Premio Total Máximo'),
                            labelPosition: 'top',
                            placeholder: _('Premio Total Máximo'),
                        },
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left],
                },
            ],
        };
        const upper_section2 = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left2],
                },
            ],
        };
        const accordion_section = {
            id: 'b5',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    paddingY: 10,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros Avanzados'),
                            body: {
                                padding: 10,
                                rows: [upper_section2],
                            },
                        },
                    ],
                },
            ],
        };
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Limpiar'),
                    width: 100,
                    click: () => {
                        $$('myForm').setValues($$('myForm').getCleanValues());
                        $$('CountrySelect').setValue($$('myForm').getCleanValues().CountrySelect);
                        $$('DateStart').setValue('');
                        $$('DateEnd').setValue('');
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'),
                    type: 'form',
                    width: 110,
                    id: 'consultDesk',
                    click: () => {
                        const filterdata = this.getRoot().getValues();
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry;
                        }
                        delete filterdata['CountrySelect2'];
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date'];
                            delete filterdata['Date2'];
                        } else {
                            if (true) {
                                delete filterdata['DateStart'];
                                delete filterdata['DateEnd'];
                            }
                        }
                        this.app.callEvent('casinoReport:filter', [filterdata]);
                        $$('b5').collapse();
                        $$('a5').scrollTo(100, 0);
                    },
                },
            ],
        };
        const buttons2 = {
            padding: 10,
            cols: [
                {
                    view: 'button',
                    value: _('Limpiar'),
                    click: () => {
                        $$('myForm2').setValues($$('myForm2').getCleanValues());
                        $$('CountrySelect').setValue($$('myForm2').getCleanValues().CountrySelect);
                        $$('DateStart').setValue('');
                        $$('DateEnd').setValue('');
                    },
                },
                {
                    view: 'button',
                    value: _('Consultar'),
                    type: 'form',
                    click: () => {
                        const filterdata = $$('myForm2').getValues();
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry;
                        }
                        delete filterdata['CountrySelect2'];
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date'];
                            delete filterdata['Date2'];
                        } else {
                            if (true) {
                                delete filterdata['DateStart'];
                                delete filterdata['DateEnd'];
                            }
                        }
                        this.app.callEvent('casinoReport:filter', [filterdata]);
                        $$('b5').collapse();
                        $$('a5').scrollTo(100, 0);
                    },
                },
            ],
        };
        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion',
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'),
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, accordion_section, buttons],
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            view: 'scrollview',
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section, accordion_section],
            },
        };
        const filterPopup = webix.ui({
            view: 'window',
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' },
                    {
                        view: 'icon',
                        icon: 'wxi-close',
                        click: function () {
                            this.getTopParentView().hide();
                        },
                    },
                ],
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm2',
                type: 'clean',
                rows: [accordion_section3, buttons2],
                rules: {
                    fname: webix.rules.isNotEmpty,
                },
            },
        });
        return {
            view: 'form',
            id: 'myForm',
            type: 'clean',
            rows: [screen.width > 500 && screen.height > 500 ? accordion_section2 : { height: 1, width: 0 }],
            rules: {
                fname: webix.rules.isNotEmpty,
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid object to initialize.
     */
    init(grid) {
        const lang = this.app.getService('locale').getLang();
        $$('TypeAwards').hide();
        $$('DateStart').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang);
        });
        $$('IsDetails').attachEvent('onChange', function (newv, oldv) {
            if ($$('IsDetails').getValue() == '1') {
                $$('TypeAwards').show();
                $$('TypeBet').hide();
            } else {
                $$('TypeBet').show();
                $$('TypeAwards').hide();
            }
        });
        webix.ready(function () {
            $$('DateStart').attachEvent('onAfterRender', function () {
                devConfig.setDateModal(lang);
            });
            $$('DateEnd').attachEvent('onAfterRender', function () {
                devConfig.setDateModal(lang);
            });
            if (profile.typeDate !== 2) {
                $$('Date').hide();
                $$('Date2').hide();
                $$('DateStart').show();
                $$('DateEnd').show();
            } else {
                if (true) {
                    $$('Date').show();
                    $$('Date2').show();
                    $$('DateStart').hide();
                    $$('DateEnd').hide();
                }
            }
        });
    }
}

// FILE DOCUMENTED
